<template>
  <div>
    <div v-if="vendor.billingKey">
      <div class="row">
        <div class="col-md-4" v-for="plan in plans" :key="plan.id">
          <plan-card :plan="plan" @pickPlan="addBilling" :vendor="vendor" />
        </div>
      </div>
      <div class="row"></div>
      <div class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-body">
            <h5 class="text-uppercase text-center text-muted my-4">
              Enterprise Plan
            </h5>
            <div
              class="row no-gutters align-items-center justify-content-center"
            >
              <div class="col-auto">
                <div class="h2 mb-0"></div>
              </div>
              <div class="col-auto">
                <div class="display-3 text-uppercase mb-0">Custom Pricing</div>
              </div>
            </div>
            <p class="text-muted text-center">
              Contact us for a custom vendor package
            </p>
            <button class="btn btn-block btn-primary">
              <icon type=""></icon>Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
    <add-billing :vendor="vendor" :plan="plan" v-if="modal.showing && plan" />
  </div>
</template>
<script>
import AddBilling from "./AddBilling";
import PlanCard from "./PlanCard";
import { mapState } from "vuex";
export default {
  name: "Billing",
  components: {
    AddBilling,
    PlanCard,
  },
  data: function () {
    return {
      plan: null,
    };
  },
  computed: {
    ...mapState(["vendors", "loading", "modal", "billing"]),
    vendor: function () {
      return this.vendors.single;
    },
    id: function () {
      return this.$route.params.id;
    },
    plans: function () {
      return this.billing.plans;
    },
  },
  mounted() {
    if (!this.vendors.single) {
      this.$store.dispatch("vendors/get", { id: this.id });
    }
  },
  methods: {
    addBilling: function (planId) {
      let plan = this.plans.filter((p) => {
        return p.id === planId;
      });
      this.plan = plan[0];
      this.$store.dispatch("showModal", "add-billing");
    },
  },
};
</script>
